// export default {
//   form: 'sovereign',
//   inputs: 'sovereign',
//   messages: 'sovereign',
//   tabs: 'sovereign',
//   buttons: 'sovereign',
//   app: 'sovereign'
// }

// export default {
//   form: 'svh-mypage',
//   inputs: 'svh-mypage',
//   messages: 'svh-mypage',
//   tabs: 'svh-mypage',
//   buttons: 'svh-mypage',
//   app: 'svh-mypage'
// }

// export default {
//   form: 'basic',
//   inputs: 'hoshi',
//   messages: 'hoshi',
//   tabs: 'basic',
//   buttons: 'hoshi'
// }

// export default {
//   form: 'neu',
//   inputs: 'neu',
//   messages: 'basic',
//   tabs: 'basic',
//   buttons: 'neu',
//   app: 'neu'
// }

// export default {
//   form: 'etu',
//   inputs: 'etu',
//   messages: 'basic',
//   tabs: 'basic',
//   buttons: 'etu',
//   app: 'etu'
// }

export default {
  form: 'ngo',
  inputs: 'ngo',
  messages: 'basic',
  tabs: 'basic',
  buttons: 'ngo',
  app: 'ngo'
}



// WEBPACK FOOTER //
// ./src/config/skins.js